// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__63Z_P","logoMobile":"Logo_logoMobile___M1Ng","logoMobileBlack":"Logo_logoMobileBlack__JLwLw","logoBlack":"Logo_logoBlack__Xd_NE"};